import { registerQuery } from '@adornis/baseql/metadata/register.js';
import { getCollection } from '@adornis/baseql/server/collections.js';
import type { BaseQLSelectionSet } from '@adornis/baseql/utils/queryGeneration.js';
import { CurrentUserInfo } from '@adornis/users/db/currentUserInfo.js';
import { ClassMembership } from '../class-membership.js';
import { Student } from '../student.js';

export const getMyClassMembershipsQuery = registerQuery({
  operationName: 'getMyClassMembershipsQuery',
  type: () => [ClassMembership],
  params: [],

  resolve: () => async (_gqlFields: BaseQLSelectionSet<ClassMembership>): Promise<ClassMembership[]> => {
    const currentUser = await CurrentUserInfo.getMyself()({ _id: 1 });
    if (!currentUser?._id) return [];

    const studentCollection = await getCollection(Student);
    const student = await studentCollection.findOne({ userID: currentUser._id });
    if (!student) return [];

    const membershipCollection = await getCollection(ClassMembership);
    const memberships = await membershipCollection
      .find({ studentID: student._id })
      .sort({ requestedAt: -1 })
      .toArray();

    return memberships as ClassMembership[];
  },
});
